import state from './chatBotState'
import mutations from './chatBotMutations'
import getters from './chatBotGetters'
import actions from './chatBotActions'

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
